/** Explicit message lookup; locale catalogs load before the application renders. */
import type { Locale } from './routing';
export { languageNames, locales, localizedPath } from './routing';
export type { Locale } from './routing';

let activeLocale: Locale = 'en';
let messages: Record<string, string> = {};
export const currentLocale = (): Locale => activeLocale;
export function configureI18n(locale: Locale, catalog: Record<string, string>) {
  activeLocale = locale;
  messages = catalog;
}
export function t(source: string | undefined, values: Record<string, string | number> = {}): string {
  if (!source) return '';
  const translated = activeLocale === 'en' ? source : messages[source] ?? source;
  return translated.replace(/\{(\w+)\}/g, (match, key: string) => key in values ? String(values[key]) : match);
}
